module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sd-header'), _vm._v(" "), _c('div', {
    staticClass: "center_wrap"
  }, [_c('div', {
    staticClass: "side_menu"
  }, _vm._l((_vm.pageGroup), function(group) {
    return _c('ul', {
      staticClass: "side_ul"
    }, _vm._l((group), function(page) {
      return _c('li', [(page.name) ? _c('router-link', {
        class: {
          on: _vm.$route.name == page.name
        },
        attrs: {
          "to": {
            name: page.name
          }
        }
      }, [_vm._v(_vm._s(page.title) + "\n            "), (page.amount && _vm.amount != 0) ? _c('span', [_vm._v("( " + _vm._s(_vm.amount) + " )")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!page.name) ? _c('a', {
        staticClass: "title"
      }, [_vm._v(_vm._s(page.title))]) : _vm._e()], 1)
    }), 0)
  }), 0)]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('sd-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf8a0564"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BaseView.vue
// module id = 870
// module chunks = 1